import { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import api from '../../api';

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Filler
);

const UsageOverTimeChart = () => {
  const [selectedRange, setSelectedRange] = useState("7");
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const fetchUsageData = async () => {
      try {
        const token =
          localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
        const baseUrl = process.env.REACT_APP_API_URL;

        const res = await api.get(
          `${baseUrl}/chat/over-usage-time?days=${selectedRange}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const usage = res.data.usage;

        const labels = usage.map((item) =>
          new Date(item.date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          })
        );

        const dataPoints = usage.map((item) => item.count);

        setChartData({
          labels,
          datasets: [
            {
              label: "Usage",
              data: dataPoints,
              borderColor: "#000",
              borderWidth: 2,
              pointBackgroundColor: "#000",
              pointRadius: 6,
              pointHoverRadius: 7,
              fill: true,
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              tension: 0,
              clip: false,
            },
          ],
        });
      } catch (error) {
        console.error("❌ Failed to fetch usage over time:", error);
      }
    };

    fetchUsageData();
  }, [selectedRange]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 20,
        right: 20,
      },
    },
    scales: {
      x: {
        offset: true,
        grid: {
          color: "#f1f1f1",
        },
        ticks: {
          font: { size: 12 },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#e0e0e0",
        },
        ticks: {
          stepSize: 20,
          font: { size: 12 },
        },
        title: {
          display: true,
          text: "Numbers of API",
          font: { size: 13, weight: "bold" },
        },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <div className="chart-card p-3 shadow-sm rounded profile-i mb-4">
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h5 className="fw-semibold mb-0">
          <span className="border-start border-4 border-dark ps-2">
            API Usage Over Time
          </span>
        </h5>

        <div className="btn-group">
          {["7", "30", "90"].map((range) => (
            <button
              key={range}
              className={`btn-sm ${
                selectedRange === range ? "btn-dark text-white" : "btn-light"
              }`}
              onClick={() => setSelectedRange(range)}
              style={{
                minWidth: "60px",
                outline: "none",
                boxShadow: "none",
                minWidth: "60px",
              }}
            >
              {range} days
            </button>
          ))}
        </div>
      </div>

      <div style={{ height: "300px", width: "100%" }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default UsageOverTimeChart;
